var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('FacilityCheckListTableComponent',{attrs:{"typeName":"設備点検","type":4,"routerName":_vm.routerName,"siteLocation":_vm.siteLocation}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }